/*
 * adaptalens-custom.js
 * Small companion script for three additions (kept out of the minified adaptalens.js bundle):
 *   1. Classification dropdown  — aria-expanded sync + Escape/outside-click close (open/close itself is CSS).
 *   2. Installment message      — recompute the per-variant amount when the variant changes.
 *   3. Free gift                — auto add/remove the configured gift line + render it as the gift row
 *                                 (works with the drawer's own client-side re-render).
 * No external dependencies.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---- money formatting (mirrors the logic in adaptalens.js) ---- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var rest = parts[1] ? decimal + parts[1] : '';
      return dollars + rest;
    }
    var value = '';
    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }

  /* =======================================================
   * 1) Classification dropdown — aria + Escape / outside click
   *    (visibility is handled by CSS :hover / :focus-within)
   * ======================================================= */
  function initDropdowns(scope) {
    (scope || document).querySelectorAll('[data-adaptalens-dd]').forEach(function (dd) {
      if (dd.dataset.alDdBound) return;
      dd.dataset.alDdBound = '1';
      var trigger = dd.querySelector('.adaptalens-header__dd-trigger');
      if (!trigger) return;
      function open() { dd.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function close() { dd.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
      dd.addEventListener('mouseenter', open);
      dd.addEventListener('mouseleave', close);
      dd.addEventListener('focusin', open);
      dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) close(); });
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (dd.classList.contains('is-open')) close(); else open();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      document.addEventListener('click', function (e) { if (!dd.contains(e.target)) close(); });
    });
  }

  /* =======================================================
   * 2) Installment message — recompute amount per variant
   * ======================================================= */
  function initInstallments(scope) {
    (scope || document).querySelectorAll('[data-installments]').forEach(function (box) {
      if (box.dataset.alInstBound) return;
      box.dataset.alInstBound = '1';
      var product = box.closest('[data-adaptalens-product]');
      if (!product) return;
      var priceEl = product.querySelector('[data-price]');
      var variantInput = product.querySelector('[data-variant-id]');
      var variantsScript = product.querySelector('[data-variants]');
      var amountEl = box.querySelector('[data-inst-amount]');
      var months = parseInt(box.getAttribute('data-inst-months'), 10) || 12;
      if (months < 1) months = 12;
      var money = box.getAttribute('data-money-format') || '${{amount}}';
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
      function update() {
        if (!amountEl || !variantInput || !variants.length) return;
        var id = String(variantInput.value);
        var v = null;
        for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) { v = variants[i]; break; } }
        if (!v) v = variants[0];
        if (!v || v.price == null) return;
        amountEl.textContent = formatMoney(Math.round(v.price / months), money);
      }
      if (priceEl && 'MutationObserver' in window) {
        new MutationObserver(update).observe(priceEl, { childList: true, characterData: true, subtree: true });
      }
      update();
    });
  }

  /* =======================================================
   * 3) Free gift — auto add/remove + gift-row rendering
   * ======================================================= */
  var giftBusy = false;
  var giftScheduled = false;

  function drawerEl() { return document.querySelector('[data-cart-drawer]'); }

  function giftConfig() {
    var d = drawerEl();
    if (!d) return null;
    var variantId = d.getAttribute('data-gift-variant-id');
    if (d.getAttribute('data-gift-enabled') !== 'true' || !variantId) return null;
    return {
      el: d,
      variantId: variantId,
      handle: d.getAttribute('data-gift-handle') || '',
      threshold: parseInt(d.getAttribute('data-gift-threshold'), 10) || 0,
      price: parseInt(d.getAttribute('data-gift-price'), 10) || 0,
      allowPaid: d.getAttribute('data-gift-allow-paid') === 'true',
      title: d.getAttribute('data-gift-title') || 'Free gift',
      code: d.getAttribute('data-gift-code') || '',
      label: d.getAttribute('data-gift-label') || '',
      value: d.getAttribute('data-gift-value') || '',
      money: d.getAttribute('data-money-format') || '${{amount}}'
    };
  }

  function isGiftItem(item, cfg) {
    if (item.properties && item.properties._free_gift) return true;
    if (cfg.variantId && String(item.variant_id) === String(cfg.variantId) && item.final_line_price === 0) return true;
    return false;
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }

  function addGift(cfg) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cfg.variantId, quantity: 1, properties: { _free_gift: 'true' } })
    });
  }

  function changeGift(key, qty) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function updateHeaderCount(count) {
    count = parseInt(count, 10);
    if (isNaN(count)) return;
    var badge = document.querySelector('.adaptalens-header__cart-count');
    var cartIcon = document.querySelector('.adaptalens-header__icon--cart');
    if (count > 0) {
      if (!badge && cartIcon) { badge = document.createElement('span'); badge.className = 'adaptalens-header__cart-count'; cartIcon.appendChild(badge); }
      if (badge) badge.textContent = count;
    } else if (badge) { badge.remove(); }
  }

  /* Rebuild drawer contents from the server (Section Rendering API), preserving open state.
     The server render already contains the fully-styled gift row. */
  function refreshDrawerContents() {
    var d = drawerEl();
    if (!d) return Promise.resolve();
    var wrap = d.closest('[id^="shopify-section-"]');
    var sectionId = wrap ? wrap.id.replace('shopify-section-', '') : 'adaptalens-cart-drawer';
    return fetch(root() + '?sections=' + encodeURIComponent(sectionId), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cart-drawer-contents]');
        var live = document.querySelector('[data-cart-drawer-contents]');
        if (fresh && live) {
          live.innerHTML = fresh.innerHTML;
          if (fresh.hasAttribute('data-cart-count')) live.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count'));
          updateHeaderCount(fresh.getAttribute('data-cart-count'));
        }
      })
      .catch(function () {});
  }

  function syncGift() {
    var cfg = giftConfig();
    if (!cfg || giftBusy) return Promise.resolve();
    return getCart().then(function (cart) {
      var giftLine = null, nonGiftCount = 0, nonGiftSubtotal = 0;
      cart.items.forEach(function (it) {
        if (isGiftItem(it, cfg)) { giftLine = it; }
        else { nonGiftCount += 1; nonGiftSubtotal += it.final_line_price; }
      });
      var qualifies = nonGiftCount > 0 && nonGiftSubtotal >= cfg.threshold;
      var canAdd = cfg.price === 0 || cfg.allowPaid;

      if (qualifies && !giftLine && canAdd) {
        giftBusy = true;
        return addGift(cfg).then(refreshDrawerContents).then(function () { giftBusy = false; styleGiftRows(); }, function () { giftBusy = false; });
      }
      if (giftLine && !qualifies) {
        giftBusy = true;
        return changeGift(giftLine.key, 0).then(refreshDrawerContents).then(function () { giftBusy = false; }, function () { giftBusy = false; });
      }
      if (giftLine && giftLine.quantity > 1) {
        giftBusy = true;
        return changeGift(giftLine.key, 1).then(refreshDrawerContents).then(function () { giftBusy = false; styleGiftRows(); }, function () { giftBusy = false; });
      }
      styleGiftRows();
    }).catch(function () {});
  }

  /* Convert a plainly-rendered gift <li> (from the drawer's own JS renderer) into the gift row.
     No-op on server-rendered gift rows (they already contain .adaptalens-drawer__gift-prices). */
  function styleGiftRows() {
    var cfg = giftConfig();
    if (!cfg) return;
    cfg.el.querySelectorAll('.adaptalens-drawer__item').forEach(function (li) {
      if (li.querySelector('.adaptalens-drawer__gift-prices')) return; // already styled (server render)
      var titleLink = li.querySelector('.adaptalens-drawer__item-title');
      var href = titleLink ? (titleLink.getAttribute('href') || '') : '';
      var path = href.split('?')[0].replace(/\/$/, '');
      var suffix = '/products/' + cfg.handle;
      var byHandle = cfg.handle && path.slice(-suffix.length) === suffix;
      if (!li.hasAttribute('data-gift-line') && !byHandle) return;

      li.classList.add('adaptalens-drawer__item--gift');
      li.setAttribute('data-gift-line', '');
      if (titleLink) titleLink.textContent = cfg.title;
      var variant = li.querySelector('.adaptalens-drawer__item-variant'); if (variant) variant.remove();
      var props = li.querySelector('.adaptalens-drawer__item-props'); if (props) props.remove();

      if (titleLink && cfg.code && !li.querySelector('.adaptalens-drawer__gift-code')) {
        var code = document.createElement('div');
        code.className = 'adaptalens-drawer__gift-code';
        code.textContent = cfg.code;
        titleLink.insertAdjacentElement('afterend', code);
      }
      if (cfg.label && !li.querySelector('.adaptalens-drawer__gift-tag')) {
        var tag = document.createElement('div');
        tag.className = 'adaptalens-drawer__gift-tag';
        tag.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg><span>' + escapeHtml(cfg.label) + '</span>';
        (li.querySelector('.adaptalens-drawer__gift-code') || titleLink).insertAdjacentElement('afterend', tag);
      }

      var prices = document.createElement('div');
      prices.className = 'adaptalens-drawer__gift-prices';
      var wasHtml = cfg.value ? '<span class="adaptalens-drawer__gift-was">' + escapeHtml(cfg.value) + '</span>' : '';
      prices.innerHTML = wasHtml + '<span class="adaptalens-drawer__gift-now">' + escapeHtml(formatMoney(0, cfg.money)) + '</span>';
      var bottom = li.querySelector('.adaptalens-drawer__item-bottom');
      if (bottom) { bottom.replaceWith(prices); }
      else { var info = li.querySelector('.adaptalens-drawer__item-info'); if (info) info.appendChild(prices); }
      var removeBtn = li.querySelector('.adaptalens-drawer__remove'); if (removeBtn) removeBtn.remove();
    });
  }

  function onDrawerChange() {
    if (giftBusy || giftScheduled) return;
    giftScheduled = true;
    requestAnimationFrame(function () {
      giftScheduled = false;
      styleGiftRows();
      var d = drawerEl();
      if (d && d.classList.contains('is-open')) syncGift();
    });
  }

  function initGift() {
    var d = drawerEl();
    if (!d) return;
    var contents = d.querySelector('[data-cart-drawer-contents]');
    if (contents && 'MutationObserver' in window && !contents.dataset.alGiftObs) {
      contents.dataset.alGiftObs = '1';
      new MutationObserver(onDrawerChange).observe(contents, { childList: true, subtree: true });
    }
    styleGiftRows();
    syncGift();
  }

  /* ---- Money-Back Guarantee fix: retag & style Horizon rich-text sections that contain the MBG copy ---- */
  function styleMbgSections(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var HEADING_MATCH = /our\s+30[-\s]day\s+money[-\s]back\s+guarantee/i;
    var sections = root.querySelectorAll('.shopify-section');
    sections.forEach(function (sec) {
      if (sec.classList.contains('lh-mbg-fixed')) return;
      var h = sec.querySelector('h1, h2, h3');
      if (!h || !HEADING_MATCH.test(h.textContent || '')) return;
      // Add a marker + swap the whole section's inner content with our card
      sec.classList.add('lh-mbg-fixed');
      var paragraphs = sec.querySelectorAll('.rich-text-block__text, .text, p');
      var bodyHtml = '';
      Array.prototype.forEach.call(paragraphs, function (p) {
        var t = p.innerHTML || '';
        if (t && !/our\s+30[-\s]day\s+money[-\s]back\s+guarantee/i.test(p.textContent || '')) {
          bodyHtml += '<p class="lh-mbg-fix__body">' + t + '</p>';
        }
      });
      // fallback if no body extracted
      if (!bodyHtml) {
        bodyHtml = '<p class="lh-mbg-fix__body">We&rsquo;re so confident that you&rsquo;ll love it that we offer a <strong>30-DAY MONEY-BACK GUARANTEE &mdash; GET YOURS WORRY FREE.</strong></p>' +
                   '<p class="lh-mbg-fix__body">If you&rsquo;re not completely satisfied, simply return it for a refund. That&rsquo;s right, just email us and we&rsquo;ll give you back your money. <em>Sound fair?</em></p>';
      }
      sec.innerHTML =
        '<div class="lh-mbg-fix">' +
          '<div class="lh-mbg-fix__wrap">' +
            '<div class="lh-mbg-fix__card">' +
              '<span class="lh-mbg-fix__ic" aria-hidden="true">' +
                '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                  '<path d="M16 4 6 7v9c0 6 4 10 10 12 6-2 10-6 10-12V7l-10-3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
                  '<path d="m12 16 3 3 6-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</span>' +
              '<h2 class="lh-mbg-fix__heading">Our 30-Day Money-Back Guarantee</h2>' +
              bodyHtml +
            '</div>' +
          '</div>' +
        '</div>';
    });
  }
  function injectMbgStyles() {
    if (document.getElementById('lh-mbg-fix-styles')) return;
    var s = document.createElement('style');
    s.id = 'lh-mbg-fix-styles';
    s.textContent =
      '.shopify-section.lh-mbg-fixed { padding: 24px 0 !important; min-height: 0 !important; margin: 0 !important; }' +
      '.lh-mbg-fix { padding: 0; }' +
      '.lh-mbg-fix__wrap { max-width: 720px; margin: 0 auto; padding: 0 20px; box-sizing: border-box; }' +
      '.lh-mbg-fix__card { background: #FBF6EA; border: 1px solid #E4D9C4; border-radius: 14px; padding: 32px 28px; text-align: center; box-sizing: border-box; }' +
      '.lh-mbg-fix__ic { display: inline-flex; align-items: center; justify-content: center; width: 48px; height: 48px; border: 1px solid #9A6B34; border-radius: 50%; color: #9A6B34; margin-bottom: 14px; }' +
      '.lh-mbg-fix__ic svg { width: 24px; height: 24px; }' +
      '.lh-mbg-fix__heading { font-family: var(--adaptalens-serif, "Fraunces", Georgia, serif); font-weight: 600; font-size: 26px; line-height: 1.2; letter-spacing: -0.01em; color: #2A211B; margin: 0 0 16px; }' +
      '.lh-mbg-fix__body { font-family: var(--adaptalens-sans, "Nunito", sans-serif); font-size: 15px; line-height: 1.65; color: #6E5D4C; margin: 0 auto 12px; max-width: 48ch; }' +
      '.lh-mbg-fix__body:last-child { margin-bottom: 0; }' +
      '.lh-mbg-fix__body strong { color: #2A211B; font-weight: 800; letter-spacing: 0.005em; }' +
      '.lh-mbg-fix__body em { font-style: italic; color: #2A211B; font-weight: 600; }' +
      '@media (max-width: 640px) {' +
        '.lh-mbg-fix__wrap { padding: 0 16px; }' +
        '.lh-mbg-fix__card { padding: 26px 20px; border-radius: 12px; }' +
        '.lh-mbg-fix__ic { width: 42px; height: 42px; margin-bottom: 12px; }' +
        '.lh-mbg-fix__ic svg { width: 22px; height: 22px; }' +
        '.lh-mbg-fix__heading { font-size: 21px; margin-bottom: 14px; }' +
        '.lh-mbg-fix__body { font-size: 14px; line-height: 1.6; margin-bottom: 10px; }' +
      '}';
    document.head.appendChild(s);
  }

  /* ---- boot ---- */
  function boot(scope) {
    initDropdowns(scope);
    initInstallments(scope);
    initGift();
    injectMbgStyles();
    styleMbgSections(scope);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
